export default __webpack_public_path__ + "static/media/Fatwa_Centre_Icon.0d5687bc.png";